import { ACTIONS } from '../Constants';

const getInitialState = () => ({
    byId: {},
    loading: false
});

export default (state = getInitialState(), action) => {
    let newById;
    let reduced;
    let newFilteredById;
    switch (action.type) {
        case ACTIONS.GET_MANY_USER_PATHWAYS_START: {
            return {
                ...state,
                loading: true
            };
        }

        case ACTIONS.GET_MANY_USER_PATHWAYS_SUCCESS: {
            newById = { ...state.byId };
            const { userPathways } = action.payload;
            userPathways.forEach((userPathway) => {
                newById[userPathway._id] = userPathway;
            });

            return {
                ...state,
                byId: newById,
                loading: false
            };
        }

        case ACTIONS.GET_USER_PATHWAY_SUCCESS:
        case ACTIONS.POST_USER_PATHWAY_SUCCESS: {
            const { userPathway } = action.payload;

            newById = {
                ...state.byId,
                [userPathway._id]: userPathway
            };
            return {
                ...state,
                byId: newById,
                loading: false,
                currentId: userPathway._id
            };
        }

        case ACTIONS.PUT_USER_PATHWAY_SUCCESS: {
            const { userPathway } = action.payload;

            newById = {
                ...state.byId,
                [userPathway._id]: userPathway
            };
            return {
                ...state,
                byId: newById,
                loading: false,
                currentId: userPathway._id
            };
        }

        case ACTIONS.CLEAR_SEARCHED_USER_PATHWAYS: {
            return {
                ...state,
                loading: false,
                filteredById: {}
            };
        }

        case ACTIONS.POST_SEARCHED_USER_PATHWAYS: {
            reduced = action.payload.userPathways.reduce((prev, userPathway) => {
                prev[userPathway._id] = userPathway;
                return prev;
            }, {});

            newFilteredById = {
                ...state.filteredById,
                ...reduced
            };

            return {
                ...state,
                filteredById: newFilteredById,
                sortOrder: action.payload.sortOrder,
                loading: false
            };
        }

        case ACTIONS.DELETE_USER_PATHWAY_SUCCESS: {
            const { userPathwayId } = action.payload;

            newById = { ...state.byId };
            delete newById[userPathwayId];

            newFilteredById = { ...state.filteredById };
            delete newFilteredById[userPathwayId];

            return {
                ...state,
                byId: newById,
                loading: false,
                filteredById: newFilteredById
            };
        }

        default:
            return state;
    }
};
